import { Grid } from "@mui/material";
import { convertToJalali } from "../../../utils/date";
import { useTranslation } from "react-i18next";

//import utils
import { numberWithCommas } from "../../../utils/utility";

//import images and icons
import { Airplane } from "iconsax-react";

// import styles
import "./confirm.scss";

function FlightInformation({ title, selectedFlight, iconName, newPrice, isTwoWay }) {
    //general variables
    const { t } = useTranslation();

    const informationList = [
        { id: 1, title: t("departure"), value: selectedFlight?.departureFaName },
        { id: 2, title: t("destination"), value: selectedFlight?.destinationFaName },
        { id: 3, title: t("airline"), value: selectedFlight?.airlinePersian },
        { id: 4, title: t("aircraft"), value: selectedFlight?.aircraft },
        { id: 5, title: t("flightNumber"), value: selectedFlight?.flightNumber },
        { id: 6, title: t("departureTimeDate"), value: selectedFlight?.departureTime + " | " + convertToJalali(selectedFlight?.departureDate) },
        { id: 7, title: t("price"), value: `${numberWithCommas(newPrice || selectedFlight?.totalPrice)} ${t("currency")}` },
    ];

    return (
        <Grid container item xs={12} md={5.9} justifyContent="center">
            <Grid className={`confirm__title ${iconName}`} container item xs={6} justifyContent="center">
                <Airplane color="var(--light-color)" variant="Bold" />
                {title}
            </Grid>

            <Grid className="confirm" container item xs={12} rowGap={2} justifyContent="space-between" alignItems="flex-start">
                {informationList.map(information => {
                    if (!!isTwoWay && information.id === 7) return null;

                    return (
                        <Grid
                            key={information?.id}
                            className="confirm__information"
                            container
                            item
                            xs={12}
                            justifyContent="space-between"
                            mx={{ xs: 2.5, xl: 0 }}
                        >
                            <span>{information.title}</span>
                            <span>{information.value}</span>
                        </Grid>
                    );
                })}
            </Grid>
        </Grid>
    );
}

export default FlightInformation;
